export { absenceApiSlice, useGetAbsenceStatusQuery } from "./absence";
